import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import {
  Box,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import TenderChip from "../SmallComponents/TenderChip";
import apiClient from "../utlis/apiClient";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { Checkbox } from "@mui/material";
import PaginationComponent from "../Common/PaginationComponent";

const ManageTender = () => {
  const [tenders, setTenders] = useState([]);
  const [drawings, setDrawings] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleTenderClick = (tender) => {
    navigate("/UpdateTender", { state: { tenderSK: tender.SK } });
  };

  const handleDelete = async (tender) => {
    setLoading(true);
    const updateDelete = {
      tableName: "Tender",
      pk: tender.PK,
      sk: tender.SK,
    };

    if (window.confirm(`Are you sure you want to delete this tender?`)) {
      try {
        const response = await apiClient.post("/api/remove", updateDelete);
        console.log(response.data);

        // Optionally, refresh tenders after deletion
        setTenders((prevTenders) =>
          prevTenders.filter((item) => item.PK !== tender.PK)
        );
      } catch (error) {
        console.error("Error deleting tender:", error);
      } finally {
        setLoading(false); // Set loading to false when fetch completes
      }
    }
  };

  useEffect(() => {
    const fetchTenders = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get(`/api/tender/Get-all-tenders`);
        console.log(response.data);
        if (response.data.success) {
          const tenderData = response.data.data || [];

          // Fetch and count files for each tender
          const tendersWithFileCount = await Promise.all(
            tenderData.map(async (tender) => {
              const fileCount = await fetchDrawings(tender.PK); // Get the file count for each tender
              return { ...tender, countFiles: fileCount }; // Add countFiles to tender
            })
          );

          console.log(tendersWithFileCount);
          setTenders(tendersWithFileCount); // Update state with new tenders
        } else {
          console.error("Failed to fetch tenders:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching tenders:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchDrawings = async (tenderPK) => {
      let fileCount = 0; // Initialize file count for the current tender
      const encodePK = encodeURIComponent(tenderPK);
      try {
        const response = await apiClient.get(
          `/api/s3-file/get-s3Attachments-By-Id/${encodePK}`
        );

        console.log(response.data);

          if (
            response.data &&
            response.data.success &&
            Array.isArray(response.data.data)
          ) {
            // Filter out false values from the data array
            const validFiles = response.data.data.filter(file => file !== false);
           

            validFiles.forEach(file => {
              if (Array.isArray(file.Location)) {
                // If Location is an array, count its elements
                fileCount += file.Location.length;
              } else if (typeof file.Location === 'object' && file.Location !== null) {
                // If Location is an object, count its keys (assumes each key is a file URL)
                fileCount += Object.keys(file.Location).length;
              }
            });

            console.log(fileCount, " the count of files inside the Location array or object");
          }


      } catch (error) {
        console.error(
          `Error fetching drawings data for PK ${tenderPK}:`,
          error
        );
      }
      return fileCount; // Return the file count
    };

    fetchTenders();
  }, []);

  const filteredItems = tenders;

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#325c67",
      color: theme.palette.common.white,
      padding: "10px",
      verticalAlign: "top",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: "10px !important",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f3f3f3",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header />
      <SubHeader />
      <Grid
        container
        sx={{ flexGrow: 1, marginTop: "-80px", padding: 0 }}
        spacing={6}
      >
        <Grid item xs={12} md={2}>
          <Box
            sx={{
              minHeight: "calc(100vh - 112px)",
              backgroundColor: "white",
              borderRadius: "10px",
              marginLeft: "15px",
              marginRight: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3 style={{ fontFamily: "Roboto, Helvetica, Arial, sans-serif" }}>
              Tender List
            </h3>

            <List sx={{ width: "100%", overflow: "auto" }}>
              {filteredItems.map((item, index) => (
                <ListItem
                  key={index}
                  button
                  onClick={() => handleTenderClick(item)}
                >
                  <ListItemText
                    primary={item.Values.TenderCodenumber}
                    primaryTypographyProps={{ fontSize: "13px" }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        </Grid>

        <Grid item xs={12} md={9}>
          <Box
            sx={{
              minHeight: "calc(100vh - 112px)",
              backgroundColor: "white",
              padding: 2,
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              marginLeft: "-50px",
            }}
          >
            <Grid
              container
              alignItems="center"
              spacing={2}
              justifyContent="space-between"
            >
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  Tender Details
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  component={Link}
                  to="/AddTender"
                  size="small"
                >
                  Add Tender
                </Button>
              </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ marginTop: 4 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>SNO</StyledTableCell>
                    <StyledTableCell>Customer Name</StyledTableCell>
                    <StyledTableCell>Tender Code Number</StyledTableCell>
                    <StyledTableCell>Drawings</StyledTableCell>
                    <StyledTableCell>PO Number</StyledTableCell>
                    <StyledTableCell>PO Received Date</StyledTableCell>
                    <StyledTableCell>Tender Due Date</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Update</StyledTableCell>
                    <StyledTableCell>Delete</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : tenders.length > 0 ? (
                    tenders
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((tender, index) => (
                      <StyledTableRow key={tender.PK}>
                        <StyledTableCell>{page * rowsPerPage + index + 1}</StyledTableCell>
                        <StyledTableCell>
                          {tender.Values.CustomerName}
                        </StyledTableCell>
                        <StyledTableCell>
                          {tender.Values.TenderCodenumber}
                        </StyledTableCell>
                        <StyledTableCell>{tender.countFiles} Files</StyledTableCell>
                        <StyledTableCell>
                          {tender.Values.PONumber}
                        </StyledTableCell>
                        <StyledTableCell>
                          {tender.Values.PORecivedDate}
                        </StyledTableCell>
                        <StyledTableCell>
                          {tender.Values.TenderDuedate}
                        </StyledTableCell>
                        <StyledTableCell>
                          <TenderChip tender={tender} />
                        </StyledTableCell>
                        <StyledTableCell>
                          <Checkbox
                            onClick={() => handleTenderClick(tender)}
                            style={{ cursor: "pointer" }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <DeleteSweepIcon
                            onClick={() => handleDelete(tender)}
                            style={{ cursor: "pointer" }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={8} align="center">
                        There Are No Tender Data.
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
              <PaginationComponent count={tenders.length} page={page} rowsPerPage={rowsPerPage} onPageChange={handleChangePage} />
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ManageTender;